import React from 'react';
import moment from "moment";
import {observer} from "mobx-react";
import {
  Invoice, INVOICE_TYPE, Payment, INVOICEPAYMENTMATCHTYPE, INVOICESTATUS,
  PAYMENT_TYPE, InvoiceGraph, PayRelation, PaymentRelation, InvRelation
} from 'invoice/domain/invoiceDomain';
import {formatDate} from "core/common/utils/dateUtils";
import { formatValue, FormProps, IDomainObject, lovLabel, lovValue, preSave } from 'core/form/formUtils';
import {abbreviate} from "core/common/utils/stringUtils";
import { green500, grey400, grey500 } from 'material-ui/styles/colors';
import {DialogAncestor, DialogProps} from "core/common/page/dialogAncestor";
import mdEntityService from "core/metamodel/mdEntityService";
import {action, observable, ObservableMap} from "mobx";
import FlatButton from "material-ui/FlatButton";
import {ErrorComp} from "core/components/errorComp/errorComp";
import Dialog from "material-ui/Dialog";
import invoiceService from "invoice/service/invoiceService";
import {createForm} from "core/form/createForm";
import {FIELDDEFDISPLAYTYPE} from "core/form/form";
import {PERMISSION, SECURABLE} from "core/metamodel/metaConstant";
import {SecuredZzFlatButton} from "core/components/buttons/buttons";
import RadioButtonField from "core/components/fields/radioButtonField";
import {Validate} from "core/form/validate";
import NumberField from "core/components/fields/numberField";
import {optionsSearch} from "core/common/service/commonDataService";
import StyledSelect from "core/components/fields/styledSelect";
import {BankTransaction, BANKTRANSACTIONTYPE, PartyCreditEntryDto} from "accounting/accountingDomain";
import {MdTextField} from "core/components/fields/fields";
import accountingService from "accounting/service/accountingService";
import partyService from "party/partyService";
import {Price} from "product/productDomain";
import {PartyCreditSumTable} from "party/component/partyCreditEntry";
import uiService from "core/common/service/uiService";
import ConfirmationDialog from "core/components/confirmationDialog/confirmationDialog";
import { DEFAULT_CURRENCY_FORMAT, formatMonetaryAmount, formatNumber } from 'core/common/utils/numberUtils';
import {addTenantToQuery} from "core/common/utils/utils";
import {Link} from "react-router";
import {SENDTYPE} from "../../core/event/eventDomain";
import Toggle from "material-ui/Toggle";
import PropTypes from "prop-types";
import { clsx } from '../../core/common/utils/domUtils';


interface InvoicePaymentCompProps {
  invoiceObject: Invoice;
}

@observer
export class InvoicePaymentComp extends React.Component<InvoicePaymentCompProps, undefined> {

  private newInvoicePaymentDialogRef: NewInvoicePaymentDialog;

  static contextTypes = {
    router: PropTypes.func.isRequired
  };


  @action addInvoicePayment = (evt) => {

    let {invoiceObject} = this.props;


    Promise.all([mdEntityService.fetchEntityMetadata(["Payment", "PaymentRelation"], ["BankTransaction"]),
      partyService.readCreditEntries(lovValue(invoiceObject.billedTo))])
      .then(([entityMap, creditEntryDto]: [any, PartyCreditEntryDto]) => {

        let newPaymentObject = new Payment({
          active: true,
          $new: true,
          //[(lovValue(invoiceObject.invoiceType) == INVOICE_TYPE.CREDIT_NOTE) ? 'creditNote' : 'invoice']: invoiceObject.invoiceLov(),
          paymentType: mdEntityService.getEntity("PaymentType").getLovItem(1),
          currency: invoiceObject.invoiceCurrency,
          matchType: INVOICEPAYMENTMATCHTYPE.MANUAL,
          valueDate: moment().startOf('day').toDate()
        }).initAfterRead(true);


        new Promise((resolve, reject) => {
          this.newInvoicePaymentDialogRef.open(resolve, reject, newPaymentObject, invoiceObject, creditEntryDto.sums);
        }).then((result: NewInvoicePaymentDialogResult) => {

          if ([INVOICE_TYPE.PR].includes(lovValue(invoiceObject.invoiceType))  && result.createInvoiceForProforma) {
            this.context.router.transitionTo("invoiceDetail", {id: 'copy'}, addTenantToQuery({
              copyId: invoiceObject.invoiceId,
              linkToFI: true,
            }));
          } else if ([INVOICE_TYPE.DP].includes(lovValue(invoiceObject.invoiceType))  && result.createDdoppForDownPayment) {
            this.context.router.transitionTo("invoiceDetail", {id: 'copy'}, addTenantToQuery({
              copyId: invoiceObject.invoiceId,
              linkToAD: true,
            }));
          } else {
            return invoiceService.readInvoiceGraph(invoiceObject.invoiceId)
              .then(action("readInvoicePayments-handler", (invoiceGraph: InvoiceGraph) => {
                invoiceObject.$invoiceGraph = invoiceGraph;
              }));
          }

        }).catch((e) => {
        })

      });


  };


  newInvoicePaymentDialogRefHandler = comp => this.newInvoicePaymentDialogRef = comp;


  render() {
    let {invoiceObject} = this.props;

    return (
      <div style={{marginBottom: 50, marginTop: 20}}>
        <NewInvoicePaymentDialog ref={this.newInvoicePaymentDialogRefHandler} entities={mdEntityService.entityMap}/>
        <InvoicePaymentTable invoiceGraph={invoiceObject.$invoiceGraph} rootInvoice={invoiceObject}/>
        <SecuredZzFlatButton label="Add Settlement" permission={PERMISSION.New} securable={SECURABLE.invoiceSettlement}
                             primary
                             disabled={invoiceObject.invoicePaid || invoiceObject.invoiceCredited}
                             onClick={this.addInvoicePayment}/>
      </div>
    );
  }

}


interface InvoicePaymentTableProps {
  invoiceGraph: InvoiceGraph;
  rootInvoice?: Invoice;
  invRelation?: InvRelation;
}

@observer
class InvoicePaymentTable extends React.Component<InvoicePaymentTableProps, undefined> {

  private confirmationDialogRef: ConfirmationDialog;

  @action deleteInvoicePayment = (payRelation: PayRelation) => {
    let { rootInvoice } = this.props;

    new Promise((resolve, reject) => {
      this.confirmationDialogRef.open(resolve, reject, 'Do you really want to delete this Settlement ?');
    }).then(() => {
      console.log('do cancel');

      uiService.showToolbarActionFlag();

      invoiceService.deleteInvoicePayment(payRelation.payment.paymentId, rootInvoice.invoiceId)
        .then((invoiceJson: any) => {
          console.log('deleteInvoicePayment invoicePaid = ' + invoiceJson.invoicePaid);
          rootInvoice.cleanAfterSave(invoiceJson);
          rootInvoice.invoicePaid = invoiceJson.invoicePaid;
          rootInvoice.invoiceCredited = invoiceJson.invoiceCredited;
          console.log('cleanAfterSave invoicePaid = ' + rootInvoice.invoicePaid);
          uiService.hideToolbarActionFlag();

          return invoiceService.readInvoiceGraph(rootInvoice.invoiceId);

        }).then(action('readInvoicePayments-handler', (invoiceGraph: InvoiceGraph) => {
        rootInvoice.$invoiceGraph = invoiceGraph;
      })).catch((error) => {
        rootInvoice.$errors = error.getMessages();
      });


    }).catch((e) => {
    });

  };


  confirmationDialogRefHandler = comp => this.confirmationDialogRef = comp;

  render() {
    let {invoiceGraph, invRelation, rootInvoice} = this.props;

    if (!invoiceGraph) {
      return <noscript/>;
    }

    return (
      <div>
        <ConfirmationDialog okButtonText="Yes" cancelButtonText="No" ref={this.confirmationDialogRefHandler}/>
        <table className="zz-simple-table">
          <tbody>
          <tr>
            <td colSpan={6} style={clsx(!rootInvoice && {borderTop: 0})}>
              <Link to="invoiceDetail" params={{ id: lovValue(invoiceGraph.invoice) }} query={addTenantToQuery()}
                    style={clsx({display: 'flex', gap: 5 }, !!rootInvoice && {fontWeight: "bold"})}>
                <span>{lovLabel(invoiceGraph.invoice.invoiceType)}</span>
                <span>{ invoiceGraph.invoice.invoiceNumber ? invoiceGraph.invoice.invoiceNumber : "Not issued"}</span>
                <span>{formatMonetaryAmount(invoiceGraph.invoice.totalAdjustedPrice, invoiceGraph.invoice.invoiceCurrency)}</span>
                <span>on</span>
                <span>{formatValue(invoiceGraph.invoice.invoiceDate, mdEntityService.getEntity("Invoice").getField('invoiceDate'))}</span>
                {!!invRelation && <span>contribution</span>}
                {!!invRelation &&
                  <span>{formatMonetaryAmount(invRelation.contributedAmount, invRelation.currency)}</span>}

              </Link>
            </td>
          </tr>
          {
            !!invoiceGraph.pays.length &&
            <tr>
              <td style={{ color: grey500, fontSize: 13 }}>Value Date</td>
              <td style={{ color: grey500, fontSize: 13 }}>Amount</td>
              <td style={{ color: grey500, fontSize: 13 }}>PaymentType</td>
              <td style={{ color: grey500, fontSize: 13 }}>Bank Transaction</td>
              <td style={{ color: grey500, fontSize: 13 }}>Match Type</td>
              <td />
            </tr>
          }
          {invoiceGraph.pays.map((payRelation, index) => {
            //let mdField = entity.getField(field.fieldName);
            return (
              <tr key={index}>
                <td>{formatDate(payRelation.valueDate)}</td>
                <td>{formatMonetaryAmount(payRelation.contributedAmount, payRelation.currency)}</td>
                <td>{lovLabel(payRelation.payment.paymentType)}</td>
                <td>{abbreviate(lovLabel(payRelation.payment.bankTransaction), 60)}</td>
                <td>{lovLabel(payRelation.payment.matchType)}</td>
                <td>
                  {
                    !!this.props.rootInvoice &&
                    <SecuredZzFlatButton label="Delete" permission={PERMISSION.Delete} secondary
                                         securable={SECURABLE.invoiceSettlement}
                                         onClick={this.deleteInvoicePayment.bind(this, payRelation)} />
                  }
                </td>
              </tr>
            );
          })}
          </tbody>
          <tbody>
          {
            invoiceGraph.froms.map((invRelation, index) => {
              return (
                <tr key={index}>
                  <td colSpan={6}>
                    <InvoicePaymentTable invoiceGraph={invRelation.node} invRelation={invRelation} />
                  </td>
                </tr>
              );
            })
          }
          {
            invoiceGraph.tos.map((invRelation, index) => {
              return (
                <tr key={index}>
                  <td colSpan={6}>
                    <InvoicePaymentTable invoiceGraph={invRelation.node} invRelation={invRelation} />
                  </td>
                </tr>
              );
            })
          }
          </tbody>
        </table>
      </div>
    );
  }

}


interface NewInvoicePaymentDialogResult {
  payment: Payment,
  paymentRelation: PaymentRelation,
  createInvoiceForProforma?: boolean;
  createDdoppForDownPayment?: boolean;
}

@observer
export class NewInvoicePaymentDialog extends DialogAncestor<DialogProps, undefined, NewInvoicePaymentDialogResult> {

  @observable private payment: Payment;
  @observable private invoiceObject: Invoice;
  @observable private createRegularInvoiceToggle: boolean;
  @observable private createDdoppToggle: boolean;
  @observable.ref private creditEntrySums: Price[];


  @action open(resolve, reject, payment: Payment, invoiceObject: Invoice, creditEntrySums: Price[]) {
    this.resolve = resolve;
    this.reject = reject;
    this.$errors = [];
    this.dialogOpen = true;
    this.payment = payment;
    this.invoiceObject = invoiceObject;
    this.creditEntrySums = creditEntrySums;
    this.createRegularInvoiceToggle = (lovValue(this.invoiceObject.invoiceType) === INVOICE_TYPE.PR);
    this.createDdoppToggle = false;
  }


  @action ok = () => {
    let result = preSave(this.payment, null);
    if (!result) {
      return;
    }

    uiService.showDialogActionFlag();

    invoiceService.saveInvoicePayment(this.payment, this.invoiceObject.invoiceId)
      .then( (struct) => {
        this.invoiceObject.cleanAfterSave(struct.invoice);
        this.dialogOpen = false;
        uiService.hideDialogActionFlag();
        this.resolve({
          payment: new Payment(struct.payment),
          paymentRelation: new PaymentRelation(struct.paymentRelation),
          createInvoiceForProforma:  [INVOICE_TYPE.PR].includes(lovValue(this.invoiceObject.invoiceType)) && this.createRegularInvoiceToggle,
          createDdoppForDownPayment:  [INVOICE_TYPE.DP].includes(lovValue(this.invoiceObject.invoiceType)) && this.createDdoppToggle
        });
      }, error => {
        this.$errors = error.getMessages();
      });

  };

  @action cancel = (evt) => {
    console.log('NewInvoicePaymentDialog#cancel evt = %O', evt);
    this.dialogOpen = false;
    this.$errors = [];

    this.reject("cancel");
  };

  @action createRegularInvoiceToggleHandler = (evt, bulik) => {
    this.createRegularInvoiceToggle = bulik;
  };

  @action createDdoppToggleHandler = (evt, bulik) => {
    this.createDdoppToggle = bulik;
  };

  render() {
    console.log('invoicePayment = %O, dialogOpen = %s', this.payment, this.dialogOpen);

    if (!(this.payment && this.dialogOpen)) return null;


    const actions = [
      <FlatButton key="1"
        label="Cancel"
        primary
        onClick={this.cancel}
      />,
      <FlatButton key="2"
        label="Save"
        secondary
        onClick={this.ok}
      />
    ];


    let propsForCreateForm = {
      dataObject: this.payment,
      rootObject: this.invoiceObject,
      entity: mdEntityService.getEntity('Payment'),
      entities: mdEntityService.entityMap
    };

    return (
      <Dialog
        title={`Create new Invoice Settlement for ${lovLabel(this.invoiceObject.invoiceType)} #${this.invoiceObject.invoiceNumber}`}
        actions={actions}
        modal={true}
        open={this.dialogOpen}
        autoScrollBodyContent={true}
        bodyStyle={{minHeight: 300}}
        contentStyle={{
          position: 'absolute',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)',
          filter: 'blur(0)'
        }}
      >
        <ErrorComp messages={this.$errors}/>
        <PaymentForm {...propsForCreateForm} open creditEntrySums={this.creditEntrySums}/>

        {[INVOICE_TYPE.PR].includes(lovValue(this.invoiceObject.invoiceType)) &&
          <Toggle label="Create new regular Invoice" toggled={this.createRegularInvoiceToggle}
                  onToggle={this.createRegularInvoiceToggleHandler} style={{width: "unset", marginTop: 20}}
                  labelStyle={{marginRight: 10, whiteSpace: 'nowrap'}}/>
        }

        {[INVOICE_TYPE.DP].includes(lovValue(this.invoiceObject.invoiceType)) &&
          <Toggle label="Create DDOPP" toggled={this.createDdoppToggle}
                  onToggle={this.createDdoppToggleHandler} style={{width: "unset", marginTop: 20}}
                  labelStyle={{marginRight: 10, whiteSpace: 'nowrap'}}/>
        }

      </Dialog>
    );
  }


}


interface PaymentFormProps extends FormProps<Payment, Invoice> {
  creditEntrySums: Price[];
}


@createForm({
  formName: 'PaymentForm',
  fields: [{
    name: 'paymentType',
    displayType: FIELDDEFDISPLAYTYPE.radioButton,
    validators: ['IsRequired']
  }, {
    name: "amount",
    validators: ['IsRequired']
  }, {
    name: "bankTransaction",
    validators: ['IsRequired']
  }, {
    name: 'comment',
    displayType: FIELDDEFDISPLAYTYPE.textArea
  }
  ]
}, () => <noscript/>)
@observer
class PaymentForm extends React.Component<PaymentFormProps, undefined> {


  @action onPaymentTypeSuccess = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onPaymentTypeSuccess ', dataObject.paymentType);

    let paymentTypeId = lovValue(dataObject.paymentType);

    if (paymentTypeId != PAYMENT_TYPE.ACCOUNT_TRANSFER) {
      dataObject.bankTransaction = null;
    }

    if (paymentTypeId == PAYMENT_TYPE.CUSTOMER_CREDIT || paymentTypeId == PAYMENT_TYPE.CASH) {
      dataObject.amount = rootObject.totalAdjustedPrice - rootObject.paidAmount;
    } else {
      dataObject.amount = null;
    }


    form.updateAllFieldsPropValue(dataObject);

  };


  @action onBankTransactionSuccess = () => {
    let {dataObject, rootObject, form} = this.props;
    console.log('onBankTransactionSuccess ', dataObject.bankTransaction);

    let bankTransactionId = lovValue(dataObject.bankTransaction);

    if (bankTransactionId) {
      return accountingService.readBankTransaction(bankTransactionId)
        .then(action("onBankTransactionSuccess-actionCb", (bankTransaction: BankTransaction) => {
          dataObject.amount = Math.min(rootObject.totalAdjustedPrice - rootObject.paidAmount, bankTransaction.amount);
          form.updateFieldsPropValue(dataObject, "amount");
        }));
    }
  };


  // @action onSuccessCounterInvoice = () => {
  //   let {dataObject, rootObject, form} = this.props;
  //   console.log('onSuccessCounterInvoice ', dataObject.counterInvoice);
  //
  //   let invoiceId = lovValue(dataObject.counterInvoice);
  //
  //   if (invoiceId) {
  //     return invoiceService.readInvoice(invoiceId)
  //       .then(action("onSuccessCounterInvoice-actionCb", (invoice: Invoice) => {
  //         dataObject.amount = Math.min(rootObject.totalAdjustedPrice - rootObject.paidAmount, invoice.totalAdjustedPrice - invoice.paidAmount);
  //         form.updateFieldsPropValue(dataObject, "amount");
  //       }));
  //   }
  // };


  render() {
    console.debug('PaymentForm render()');

    let {dataObject, rootObject, entities, index, formName, creditEntrySums} = this.props;
    let {paymentType, amount, bankTransaction, comment}
      = dataObject.getFormFields(formName);

    let invoiceTypeId = lovValue(rootObject.invoiceType);
    let paymentTypeId = lovValue(dataObject.paymentType);
    let paymentTypesWoCN = paymentType.props.options.filter(lov => ![PAYMENT_TYPE.CREDIT_NOTE, PAYMENT_TYPE.MUTUAL_CREDIT].includes(lovValue(lov)));


    return (
      <form>

        <div className="row" style={{marginTop: 5, marginBottom: 5}}>
          <div className="col-xs-12">
            <RadioButtonField {...paymentType.props} options={paymentTypesWoCN} groupStyle={{display: 'flex', flexWrap: 'wrap'}}
                              optionStyle={{width: 'initial', marginRight: 15}}
                              labelStyle={{whiteSpace: 'nowrap', marginLeft: -10}}/>
            <Validate field={paymentType} value={paymentType.props.value} onSuccess={this.onPaymentTypeSuccess}/>
          </div>
        </div>

        <div className="row">
          {(paymentTypeId == PAYMENT_TYPE.ACCOUNT_TRANSFER) ? (
            <div className="col-xs-10">
              <StyledSelect {...bankTransaction.props} minimumInput={0}
                            async clearable asterixForAll loadOptions={optionsSearch.bind(this, 'BankTransaction', {
                accountPartyId: lovValue(rootObject.billedFrom),
                transactionType: BANKTRANSACTIONTYPE.PAYMENT_IN,
                settled: false
              })}
                            advancedSearchGL="bankTransactionSearch"
                            advancedSearchMasterId={lovValue(rootObject.billedFrom)}
                            advancedSearchContentStyle={{width: '80%', maxWidth: 'none'}} advancedSearchShowGridConfig advancedSearchTitle={`Search payment for ${lovLabel(rootObject.invoiceType)} #${rootObject.invoiceNumber} - ${lovLabel(rootObject.billedTo)}, amount ${formatNumber(rootObject.totalAdjustedPrice, DEFAULT_CURRENCY_FORMAT)} ${lovLabel(rootObject.invoiceCurrency)}`}/>
              <Validate field={bankTransaction} value={bankTransaction.props.value}
                        onSuccess={this.onBankTransactionSuccess}/>
            </div>
          ) : null}

          {/*{(paymentTypeId == PAYMENT_TYPE.MUTUAL_CREDIT) ? (*/}
          {/*  <div className="col-xs-12 col-sm-6">*/}
          {/*    <StyledSelect  {...counterInvoice.props} async asterixForAll*/}
          {/*                   loadOptions={optionsSearch.bind(this, 'Invoice', {*/}
          {/*                     invoiceStatus: [INVOICESTATUS.ISSUED],*/}
          {/*                     billedTo: lovValue(rootObject.billedFrom),*/}
          {/*                     invoiceType: INVOICE_TYPE.INVOICE*/}
          {/*                   })} clearable/>*/}
          {/*    <Validate field={counterInvoice} value={counterInvoice.props.value}*/}
          {/*              onSuccess={this.onSuccessCounterInvoice}/>*/}
          {/*  </div>*/}
          {/*) : null}*/}

          {(paymentTypeId == PAYMENT_TYPE.CUSTOMER_CREDIT) ? (
            <div className="col-xs-12">
              <PartyCreditSumTable sums={creditEntrySums}/>
            </div>
          ) : null}

        </div>

        <div className="row">
          <div className="col-xs-6 col-sm-6">
            <NumberField {...amount.props} />
            <Validate field={amount} value={amount.props.value}/>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <MdTextField {...comment.props} multiLine={true} rows={2}/>
          </div>
        </div>


      </form>


    );
  }
}






// WEBPACK FOOTER //
// ./src/invoice/component/invoicePayment.tsx